@import 'styles/mixins';
@import 'styles/variables';

.countIndicator {
  @include sm-semibold;

  background-color: $grey-5;
  border-radius: 4px;
  color: $grey-50;
  padding: 2px 6px;
  width: fit-content;
}

.countIndicator.lightGray {
  color: $grey-40;
}
